import { FormattedMessage } from "react-intl";
import { ListItem, url } from "lcm-iot-commons";
import { opcUaServerShape } from "../../shapes/opcUaServersShape";
import {
  opcUaServerIconClassName,
  opcUaServerStatusIconClassName,
} from "../../utils/statusUtils";

type Props = {
  opcUaServer: opcUaServerShape;
};

export function OpcUaServerItem(props: Readonly<Props>) {
  const { opcUaServer } = props;
  const status = opcUaServer.status || "undefined";
  const hostname = opcUaServer.hostname ? (
    <div className="list-item-details">
      <span>
        opc.tcp://
        {opcUaServer.hostname}
        :62541/Server
      </span>
    </div>
  ) : (
    "-"
  );

  const opcServerDescription = () => (
    <>
      <span
        id="list-item-details-icon-icon"
        className={opcUaServerStatusIconClassName(status)}
      />
      <span id="list-item-details-icon-description">
        <FormattedMessage id={`enum.opc_ua_server.${status}`} />
      </span>
    </>
  );

  return (
    <ListItem
      target={url(
        `/subscriptions/connect/${opcUaServer.subscription_id}/opc_ua_servers/${opcUaServer.id}`,
      )}
      id={`opc-ua-server-item-${opcUaServer.id}`}
      title={hostname}
      description={opcServerDescription()}
      icon={opcUaServerIconClassName()}
    />
  );
}

export default OpcUaServerItem;
